<div class="avatar">
    <ion-button *ngIf="isClickable" class="avatar-button" (click)="onButtonClick()">
        <ng-content *ngTemplateOutlet="avatarContent"></ng-content>
    </ion-button>

    <ng-container *ngIf="!isClickable">
        <ng-content *ngTemplateOutlet="avatarContent"></ng-content>
    </ng-container>

    <div
        class="avatar-badge-container"
        [ngClass]="{ 'avatar-badge-container--edit': badgeType === 'edit' }"
        *ngIf="badgeType">
        <div class="avatar-badge avatar-badge--edit" *ngIf="badgeType === 'edit'">
            <lib-svg-icon iconName="pen-fill" [size]="16" />
        </div>
    </div>
</div>

<ng-template #avatarContent>
    <div
        class="{{ size ? 'avatar-' + size : undefined }} avatar-wrapper avatar-background {{ avatarClasses }}"
        [ngStyle]="{
            position: imageLoadError || loadingImg ? 'absolute' : '',
            opacity: imageLoadError || loadingImg ? '0' : ''
        }"
        [style.width]="customSize ? customSize + 'px' : undefined"
        [style.height]="customSize ? customSize + 'px' : undefined"
        [style.border-color]="borderColor"
        [style.border-width]="borderColor ? '1px ' : 0"
        [style.border-style]="borderColor ? 'solid' : undefined"
        [ngClass]="{
            'avatar-border-white': defaultBorder,
            'block-center': centered
        }">
        <ion-img
            [src]="image"
            alt="Profile picture of {{ name }}"
            (ionError)="imageError()"
            (ionImgWillLoad)="loadingImage()"
            (ionImgDidLoad)="loadedImage()"
            class="avatar-image"></ion-img>
    </div>

    <div
        *ngIf="image === null || image === '' || loadingImg === true || imageLoadError === true"
        class="user-avatar-initials {{ size ? 'avatar-' + size : undefined }} avatar-background {{ avatarClasses }}"
        [style.background-color]="backgroundColor || undefined"
        [style.width]="customSize ? customSize + 'px' : undefined"
        [style.height]="customSize ? customSize + 'px' : undefined"
        [style.border-color]="borderColor"
        [style.border-width]="borderColor ? '1px ' : 0"
        [style.border-style]="borderColor ? 'solid' : undefined"
        [ngClass]="{ 'avatar-border-white': defaultBorder, 'block-center': centered }">
        <span
            *ngIf="initials"
            class="user-avatar-initials-text sr-only"
            [style.--color]="initialsTextColor"
            [style.font-size]="customTextSize ? customTextSize + 'px' : undefined">
            {{ initials }}
        </span>
        <div class="user-avatar-default-icon">
            <lib-svg-icon iconName="user-fill" color="var(--ion-color-dark-40)" [size]="customTextSize || 28" />
        </div>
    </div>
</ng-template>
